import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token'),
    // 添加 loading 状态
    loading: {
      isLoading: false,
      count: 0
    }
  },
  
  getters: {
    isAuthenticated: state => !!state.token,
    getToken: state => state.token,
    // 添加 loading 的 getter
    isLoading: state => state.loading.isLoading
  },
  
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_TOKEN(state) {
      state.token = null
      localStorage.removeItem('token')
    },
    // 添加 loading 相关的 mutations
    SHOW_LOADING(state) {
      state.loading.count++
      state.loading.isLoading = true
    },
    HIDE_LOADING(state) {
      state.loading.count--
      if (state.loading.count <= 0) {
        state.loading.count = 0
        state.loading.isLoading = false
      }
    },
    RESET_LOADING(state) {
      state.loading.count = 0
      state.loading.isLoading = false
    }
  },
  
  actions: {
    login({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    logout({ commit }) {
      commit('CLEAR_TOKEN')
    },
    // 添加 loading 相关的 actions
    showLoading({ commit }) {
      commit('SHOW_LOADING')
    },
    hideLoading({ commit }) {
      commit('HIDE_LOADING')
    },
    resetLoading({ commit }) {
      commit('RESET_LOADING')
    }
  }
})